<template>
    <input ref="inputRef" type="text" :id="id" :name="name" class="currency-input" />
</template>

<script>
import { watch } from "vue";
import { useCurrencyInput } from "vue-currency-input";
import { watchDebounced } from "@vueuse/core";

export default {
    name: "CurrencyInput",
    props: {
        value: Number | String, // Vue 2: value
        options: Object,
        id: String,
        name: String,
        change: Function,
        key_input: String,
        initialValue: Number | String,
        isLoading: Boolean,
    },
    setup(props, { emit }) {
        const { inputRef, numberValue, setValue } = useCurrencyInput(
            {
                ...props.options,
                locale: 'en-US',
                currencyDisplay: "narrowSymbol"
            },
            false
        );

        watch(
            () => props.value, // Vue 2: props.value
            (value) => {
                setValue(value);
            }
        );

        watchDebounced(
            numberValue,
            (value) => {
                emit("input", value);
                if (props.change) {
                    if (!props.isLoading)
                        props.change(value, props.key_input);
                }
            },
            {
                debounce: 100,
            }
        );

        return { inputRef };
    },
};
</script>
